import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';

export function RevalidateButton({
  accountId,
  onStarted,
}: {
  accountId: string;
  onStarted: (workflowId: string) => void;
}) {
  const m = useMutation({
    mutationFn: () => api.validateAccount(accountId),
    onSuccess: (res) => {
      toast.success('Re-validating…');
      onStarted(res.workflow_id);
    },
    onError: (err) => toast.error('Validate failed', { description: String(err) }),
  });
  return (
    <Button size="sm" variant="outline" onClick={() => m.mutate()} disabled={m.isPending}>
      {m.isPending ? 'Starting…' : 'Re-validate'}
    </Button>
  );
}
